(function ($, Drupal, once) {

  /**
   * Animate an accordion item open.
   */
  function openAccordion(item, content) {
    item.open = true;
    content.style.height = '0';

    requestAnimationFrame(function () {
      content.style.height = content.scrollHeight + 'px';
    });

    content.addEventListener('transitionend', function handler() {
      content.style.height = 'auto';
      content.removeEventListener('transitionend', handler);
    });
  }

  /**
   * Animate an accordion item closed.
   */
  function closeAccordion(item, content) {
    content.style.height = content.scrollHeight + 'px';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        content.style.height = '0';
      });
    });

    content.addEventListener('transitionend', function handler() {
      item.open = false;
      content.style.height = '';
      content.removeEventListener('transitionend', handler);
    });
  }

  Drupal.behaviors.accordionStack = {
    attach: function attach(context, settings) {
      once('accordionStack', '.accordion-stack__item', context).forEach(function (item) {
        var summary = item.querySelector('.accordion-stack__trigger');
        var content = item.querySelector('.accordion-stack__content');

        if (item.open) {
          content.style.height = 'auto';
        }

        summary.addEventListener('click', function (e) {
          e.preventDefault();

          if (item.open) {
            closeAccordion(item, content);
          } else {
            var stack = item.closest('.lb-block--accordion-stack');
            if (stack) {
              stack.querySelectorAll('.accordion-stack__item[open]').forEach(function (sibling) {
                if (sibling !== item) {
                  var siblingContent = sibling.querySelector('.accordion-stack__content');
                  closeAccordion(sibling, siblingContent);
                }
              });
            }

            openAccordion(item, content);
          }
        });
      });
    }
  };

})(jQuery, Drupal, once);
